
import { PropTypes } from 'prop-types';
import { MdOutlineKeyboardDoubleArrowLeft } from 'react-icons/md';

const Heading = ({ name,color,size="text-sm" }) => {
    return (
        <span className={`uppercase flex gap-1 items-center justify-start w-fit  text-xs 2xl:${size} font-bold ${color}`}>{name}<MdOutlineKeyboardDoubleArrowLeft /></span>
    )
}
Heading.propTypes = {
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
    size: PropTypes.string
}
export default Heading